import { simpleMemoize } from './simpleMemoize';
var WEBKIT_STICKY = '-webkit-sticky';
var STICKY = 'sticky';
export var positionStickyCssValue = simpleMemoize(function () {
    if (typeof document === 'undefined') {
        return STICKY;
    }
    var node = document.createElement('div');
    node.style.position = WEBKIT_STICKY;
    return node.style.position === WEBKIT_STICKY ? WEBKIT_STICKY : STICKY;
});
